import axios from 'axios';
import { API_ENDPOINT, API_TOKEN } from '../config/api';
import * as Storage from "../utils/storage";
import { storageKeys } from "../constants/storage";
import { NEW_TOKEN_URL } from '../constants/Url';

const httpClient = axios.create({
  baseURL: API_ENDPOINT,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    Accept: "application/json",
    "x-api-token": API_TOKEN
  },
});

httpClient.interceptors.request.use(
    async (config) => {

      let token = Storage.getString(storageKeys.TOKEN);

      if (token) {
        const jwtPayload = JSON.parse(atob(token.split('.')[1]));
        const JWTtime = jwtPayload.exp * 1000;
        if (Date.now() >= JWTtime) {
          token = await getNewToken()?.accessToken;
        } else if (JWTtime - Date.now() < 70000) {
          token = await getNewToken()?.accessToken;
        }
      }

        // DO NOT overwrite headers completely
        config.headers = {
            ...config.headers,
            Accept: "application/json",
        };

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let convertedError = error;
    const response = error?.response;
    if ((response?.data?.message == "Invalid or Expired Token; Please login again" && response?.status === 401) ||
        (response?.data?.message == "Invalid tokens" && response?.status === 401) ||
        (response?.data?.message == "Unauthorized" && response?.status === 401)
    ) {
        // localStorage.removeItem(storageKeys.TOKEN)
        // localStorage.removeItem(storageKeys.USER)
        // window.location = "/admin/login"
        Storage.handleLogout();
    }
    try {
      return Promise.reject(error?.response?.data);
    } catch (error) {
      return Promise.reject(error?.response?.data);
    }
  }
);

export default httpClient;


export const getNewToken = async () => {
  const refreshToken = Storage.getString(storageKeys.TOKEN_RE);
  let token = Storage.getString(storageKeys.TOKEN);
  const response = await fetch(
    `${API_ENDPOINT}${NEW_TOKEN_URL}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-api-token": API_TOKEN,
        Authorization: `Bearer ${refreshToken}`
      },
      credentials: "include"
    }
  );

  const res = await response.json();

  if (res?.status === 200) {
    Storage.tokenSuccessAction(res?.accessToken)
  } else {
    // return res
    // Storage.handleLogout();
  }
  return res
}